import clsx from "classnames";
import ContactButton from "@/components/ContactButton";
import classes from "./styles.module.scss";
import Link from 'next/link';
export default function ConsultantCard({ consultant={}, className }) {

  return (
     <div className={classes.consultant_card}>
        <Link href={"/consultants/" + consultant.url_slug} passHref>
          <img alt={consultant.name} src={consultant.profile_image ?? '/profile_placeholder.jpg'} className={classes.profile_img}></img>
        </Link>
        <div className={classes.consultant_details}>
          <div className={classes.role}>{consultant.position_title}</div>
          <Link href={"/consultants/" + consultant.url_slug} passHref>
            <h3 className={classes.name}>{consultant.name}</h3>
          </Link>
          {
            consultant.specialisms &&
            <div className={classes.specialty}>
              Specialisms: {
                consultant.specialisms ? (
                  typeof(consultant.specialisms) == "object" ? consultant.specialisms?.join(', ') : consultant.specialisms
                ) : "-"
              }
            </div>
          }
        </div>
        <div className={classes.socials}>
            <ContactButton hoverType="dark" href={"mailto:" + consultant.email} icon="/icons/envelope.png" alt="envelope"></ContactButton>
            <ContactButton hoverType="dark" href={"tel:" + consultant.phone} icon="/icons/call.png" alt="phone"></ContactButton>
            <ContactButton hoverType="dark" href={consultant.linkedin} icon="/icons/linkedin.png" alt="linkedin"></ContactButton>
        </div>
      </div>        
  );
}

ConsultantCard.defaultProps = {
  className: "",
};
